<template>
    <v-btn
        color="primary"
        class="link-back"
        :disabled="disabled"
        :ripple="false"
        plain
        @click="goBack"
    >
        <v-icon
            size="22"
            aria-hidden="true"
            left
        >
            mdi-chevron-left
        </v-icon>

        <span>
            <slot>{{ text }}</slot>
        </span>
    </v-btn>
</template>

<script>
/**
 * A "Back" link button that navigates to the previous page, or a specified route.
 *
 * @example
 * <link-back />
 *
 * @example
 * <link-back to="{ name: 'dashboard' }">Back to Dashboard</link-back>
 */

export default {
    name: 'LinkBack',

    props: {
        /**
         * The text to display inside the link. Defaults to "Back".
         */
        text: {
            type: String,
            default: 'Back'
        },

        /**
         * Whether the link is in a disabled state.
         */
        disabled: {
            type: Boolean,
            default: false
        },

        /**
         * The route to navigate to when clicked. If not provided, will navigate back in history.
         */
        to: {
            type: [String, Object],
            default: null
        },

        /**
         * The route to navigate to if there is no history to go back to.
         */
        fallback_route: {
            type: [String, Object],
            default: null
        }
    },

    methods: {
        goBack() {
            if (this.to) {
                this.$router.push(this.to)
            } else if (this.$router && window.history.length > 1) {
                this.$router.back()
            } else if (this.fallback_route) {
                this.$router.push(this.fallback_route)
            } else {
                this.$router.push('/')
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.link-back {
    text-transform: none;
    font-weight: bold;
    justify-content: flex-start;

    .v-btn__content {
        justify-content: flex-start;
    }
}
</style>
